import { IconDefinition } from "@fortawesome/fontawesome-svg-core"

import { faIcon } from "@utils/faIcon"

type ObjectMap = {
    [key in ObjectType]: {
        label: ObjectsNamesSinglular
        labelPlural: ObjectsNames
        icon: IconDefinition
        iconActive: IconDefinition
    }
}

export const objectMap: ObjectMap = {
    estimate: {
        label: "Estimate",
        labelPlural: "Estimates",
        icon: faIcon({ name: "file-lines", style: "regular" }),
        iconActive: faIcon({ name: "file-lines", style: "solid" }),
    },
    client: {
        label: "Client",
        labelPlural: "Clients",
        icon: faIcon({ name: "buildings", style: "regular" }),
        iconActive: faIcon({ name: "buildings", style: "solid" }),
    },
    job: {
        label: "Job",
        labelPlural: "Jobs",
        icon: faIcon({ name: "wrench-simple", style: "regular" }),
        iconActive: faIcon({ name: "wrench-simple", style: "solid" }),
    },
    job_series: {
        label: "Job Series",
        labelPlural: "Job Series",
        icon: faIcon({ name: "wrench-simple", style: "regular" }),
        iconActive: faIcon({ name: "wrench-simple", style: "solid" }),
    },
    invoice: {
        label: "Invoice",
        labelPlural: "Invoices",
        icon: faIcon({ name: "circle-dollar", style: "regular" }),
        iconActive: faIcon({ name: "circle-dollar", style: "solid" }),
    },
    credit_note: {
        label: "Credit Note",
        labelPlural: "Credit Notes",
        icon: faIcon({ name: "circle-dollar", style: "regular" }),
        iconActive: faIcon({ name: "circle-dollar", style: "solid" }),
    },
    purchase_order: {
        label: "Purchase Order",
        labelPlural: "Purchase Orders",
        icon: faIcon({ name: "basket-shopping", style: "regular" }),
        iconActive: faIcon({ name: "basket-shopping", style: "solid" }),
    },
    bill: {
        label: "Bill",
        labelPlural: "Bills",
        icon: faIcon({ name: "file-invoice-dollar", style: "regular" }),
        iconActive: faIcon({ name: "file-invoice-dollar", style: "solid" }),
    },
    pricebook_item: {
        label: "Pricebook Item",
        labelPlural: "Pricebook",
        icon: faIcon({ name: "tag", style: "regular" }),
        iconActive: faIcon({ name: "tag", style: "solid" }),
    },
    vendor: {
        label: "Vendor",
        labelPlural: "Vendors",
        icon: faIcon({ name: "store", style: "regular" }),
        iconActive: faIcon({ name: "store", style: "solid" }),
    },
}
